var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDefaultSelected = function SvgDefaultSelected(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.021 4.322-4.284 5.775 4.284 5.7h2.596l-4.359-5.737 4.247-5.738z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.894 4.323 4.284 5.775-4.284 5.7H4.298l4.359-5.738L4.41 4.323z"
  }))));
};
export default SvgDefaultSelected;